var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_131_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.365 8.36588L14.8546 12.5171C9.20243 14.0298 6.85801 18.0853 8.37237 23.7305L12.524 39.2067C14.0384 44.8518 18.0988 47.1931 23.751 45.6804L39.2614 41.5292C44.9136 40.0165 47.2433 35.9649 45.7289 30.3198L41.5773 14.8435C40.0629 9.1984 36.0172 6.85312 30.365 8.36588Z",
    fill: "url(#paint0_linear_131_450)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_131_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0076 28.6477L36.191 17.9907C35.1693 14.1251 32.6123 12.3918 29.2502 13.2784L17.863 16.281C14.4457 17.1821 13.1225 19.9386 14.1442 23.8041L16.9608 34.4611C17.9989 38.389 20.495 40.0703 23.9123 39.1692L35.2995 36.1666C38.6616 35.28 40.0457 32.5755 39.0076 28.6477Z",
    fill: "#E9747E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_131_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8491 15.6668H27.7931C21.9421 15.6668 18.627 18.9781 18.627 24.8223V40.8445C18.627 46.6888 21.9421 50 27.7931 50H43.8491C49.7002 50 53 46.6888 53 40.8445V24.8223C53 18.9781 49.7002 15.6668 43.8491 15.6668",
    fill: "white",
    fillOpacity: 0.35
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_131_450)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_131_450",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8743 22.6863C35.0952 22.6863 34.4535 23.3272 34.4535 24.1206V41.5467C34.4535 42.3249 35.0952 42.9658 35.8743 42.9658C36.6687 42.9658 37.3103 42.3249 37.3103 41.5467V24.1206C37.3103 23.3272 36.6687 22.6863 35.8743 22.6863ZM27.8539 28.3174C27.0748 28.3174 26.4331 28.9583 26.4331 29.7518V41.5472C26.4331 42.3254 27.0748 42.9663 27.8539 42.9663C28.6483 42.9663 29.2899 42.3254 29.2899 41.5472V29.7518C29.2899 28.9583 28.6483 28.3174 27.8539 28.3174ZM42.3519 35.9774C42.3519 35.1839 42.9935 34.5431 43.7879 34.5431C44.567 34.5431 45.2087 35.1839 45.2087 35.9774V41.547C45.2087 42.3253 44.567 42.9661 43.7726 42.9661C42.9935 42.9661 42.3519 42.3253 42.3519 41.547V35.9774Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8743 22.6863C35.0952 22.6863 34.4535 23.3272 34.4535 24.1206V41.5467C34.4535 42.3249 35.0952 42.9658 35.8743 42.9658C36.6687 42.9658 37.3103 42.3249 37.3103 41.5467V24.1206C37.3103 23.3272 36.6687 22.6863 35.8743 22.6863ZM27.8539 28.3174C27.0748 28.3174 26.4331 28.9583 26.4331 29.7518V41.5472C26.4331 42.3254 27.0748 42.9663 27.8539 42.9663C28.6483 42.9663 29.2899 42.3254 29.2899 41.5472V29.7518C29.2899 28.9583 28.6483 28.3174 27.8539 28.3174ZM42.3519 35.9774C42.3519 35.1839 42.9935 34.5431 43.7879 34.5431C44.567 34.5431 45.2087 35.1839 45.2087 35.9774V41.547C45.2087 42.3253 44.567 42.9661 43.7726 42.9661C42.9935 42.9661 42.3519 42.3253 42.3519 41.547V35.9774Z",
    fill: "url(#paint1_linear_131_450)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8535 24.1206C34.8535 23.5457 35.3184 23.0863 35.8743 23.0863V22.2863C34.8719 22.2863 34.0535 23.1086 34.0535 24.1206H34.8535ZM34.8535 41.5467V24.1206H34.0535V41.5467H34.8535ZM35.8743 42.5658C35.3156 42.5658 34.8535 42.1035 34.8535 41.5467H34.0535C34.0535 42.5462 34.8747 43.3658 35.8743 43.3658V42.5658ZM36.9103 41.5467C36.9103 42.1007 36.451 42.5658 35.8743 42.5658V43.3658C36.8864 43.3658 37.7103 42.549 37.7103 41.5467H36.9103ZM36.9103 24.1206V41.5467H37.7103V24.1206H36.9103ZM35.8743 23.0863C36.4482 23.0863 36.9103 23.5485 36.9103 24.1206H37.7103C37.7103 23.1058 36.8892 22.2863 35.8743 22.2863V23.0863ZM26.8331 29.7518C26.8331 29.1769 27.298 28.7174 27.8539 28.7174V27.9174C26.8515 27.9174 26.0331 28.7397 26.0331 29.7518H26.8331ZM26.8331 41.5472V29.7518H26.0331V41.5472H26.8331ZM27.8539 42.5663C27.2952 42.5663 26.8331 42.104 26.8331 41.5472H26.0331C26.0331 42.5467 26.8543 43.3663 27.8539 43.3663V42.5663ZM28.8899 41.5472C28.8899 42.1012 28.4306 42.5663 27.8539 42.5663V43.3663C28.866 43.3663 29.6899 42.5495 29.6899 41.5472H28.8899ZM28.8899 29.7518V41.5472H29.6899V29.7518H28.8899ZM27.8539 28.7174C28.4278 28.7174 28.8899 29.1797 28.8899 29.7518H29.6899C29.6899 28.737 28.8687 27.9174 27.8539 27.9174V28.7174ZM43.7879 34.1431C42.773 34.1431 41.9519 34.9626 41.9519 35.9774H42.7519C42.7519 35.4053 43.214 34.9431 43.7879 34.9431V34.1431ZM45.6087 35.9774C45.6087 34.9654 44.7903 34.1431 43.7879 34.1431V34.9431C44.3438 34.9431 44.8087 35.4025 44.8087 35.9774H45.6087ZM45.6087 41.547V35.9774H44.8087V41.547H45.6087ZM43.7726 43.3661C44.7847 43.3661 45.6087 42.5494 45.6087 41.547H44.8087C44.8087 42.1011 44.3493 42.5661 43.7726 42.5661V43.3661ZM41.9519 41.547C41.9519 42.5466 42.773 43.3661 43.7726 43.3661V42.5661C43.214 42.5661 42.7519 42.1039 42.7519 41.547H41.9519ZM41.9519 35.9774V41.547H42.7519V35.9774H41.9519Z",
    fill: "url(#paint2_linear_131_450)",
    mask: "url(#path-4-inside-1_131_450)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_131_450",
    x: -5.07761,
    y: -5.08331,
    width: 64.258,
    height: 64.2133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_131_450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_131_450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_131_450",
    x: 0.807678,
    y: 0.0509644,
    width: 51.5381,
    height: 52.3559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_131_450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_131_450",
    x: 3.62698,
    y: 0.666809,
    width: 64.373,
    height: 64.3332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_131_450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_131_450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_131_450",
    x: 11.4331,
    y: 7.68628,
    width: 48.7755,
    height: 50.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_131_450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_131_450",
    result: "effect2_dropShadow_131_450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_131_450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_450",
    x1: 30.0909,
    y1: 28.5916,
    x2: 4.74187,
    y2: 50.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_131_450",
    x1: 21.5731,
    y1: 37.7385,
    x2: 30.3519,
    y2: 55.7942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_131_450",
    x1: 29.4219,
    y1: 25.0489,
    x2: 42.5325,
    y2: 40.0822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.b469d6c54dd59442b305be097aee85d2.svg";
export { ForwardRef as ReactComponent };